"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = getExistingReleaseBranch;
const range_1 = __importDefault(require("lodash/range"));
function getExistingReleaseBranch(execSync, prompt) {
    const existingReleaseHotfixBranches = execSync('git branch --color=never -r | grep -E "release--|hotfix--|minor-release--"')
        .toString()
        .replace(/ /g, '')
        .replace(/origin\//g, '')
        .split('\n')
        .filter(Boolean);
    if (existingReleaseHotfixBranches.length > 1) {
        const selectionMap = {};
        console.log('There is more than one release/hotfix branch present. You should clean them up. In the meantime, select the one you want:');
        console.log('\n');
        const selectionPrompt = existingReleaseHotfixBranches.map((branchName, index) => {
            selectionMap[parseInt(index, 10)] = branchName;
            return `${index}: ${branchName}`;
        });
        const userSelection = parseInt(prompt(`${selectionPrompt.join('\n')}\nType the number and hit enter: `), 10);
        if (!(0, range_1.default)(0, existingReleaseHotfixBranches.length).includes(userSelection)) {
            console.error('You need to select an appropriate number. Try again!');
            process.exit(1);
        }
        return selectionMap[userSelection];
    }
    return existingReleaseHotfixBranches[0];
}
